export default __webpack_public_path__ + "static/media/35.46d9d6a6.jpg";